export class CashierResponse {
	id: number;
	amount: number;
	amountForeign: number;
	manager: number;
	company: number;
	name: string;
	description: string;
	active: boolean;
	currency: number;
	account4: number;
	withInitialBalance: boolean = true;
	minimum: number;
	maximum: number;
	warehouse = null;
	minimumForeign: number;
	maximumForeign: number;
	noAlertOnSells: boolean = false;
	//for frontend
	allMoves!: MoveCashResponse[];
	filteredMoves!: MoveCashResponse[];

	constructor() {

	}
}

export class MoveCashResponse {
	id: number;
	mdate: number;
	docTypeDescription: string;
	document: number;
	moveAmount: number;
	transactionType: string;
	currencyDescription: string;
	cashName: string;
	cashDescription: string;
	cashStatus: string;
	employeeEmail: string;
	employeeAlpha: string;
}